import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpHeaders,
} from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor() { }
  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    /*return next.handle(
      (httpRequest.url.includes('create') || httpRequest.url.includes('authenticate') || httpRequest.url.includes('getAllPays') || httpRequest.url.includes("forgetEnseignePassword")) ?
        (
          !(httpRequest.url.includes('createEnseigneUser') || httpRequest.url.includes('createEnseigneAgence') || httpRequest.url.includes("createEnseignePassword") || httpRequest.url.includes("createEnseigneCommandeEcarte") || httpRequest.url.includes("createEnseigneEnvoiEcarte"))

            ? httpRequest :

            httpRequest.clone({
              headers: new HttpHeaders({
                Token: JSON.parse(localStorage.getItem('enseigne')).Token
              })
            })
        )
        :
        httpRequest.clone({
          headers: new HttpHeaders({
            Token: JSON.parse(localStorage.getItem('enseigne')).Token
          })
        })

    )*/
    const length = httpRequest.url.split("/").length;
    return next.handle(
      httpRequest.url.includes("authenticate") || httpRequest.url.includes("pays") || httpRequest.url.split("/")[length-1] === "forgetPassword" ?         
      httpRequest :
      httpRequest.clone({
        headers: new HttpHeaders({
          Token: JSON.parse(localStorage.getItem('enseigne')).Token
        })
      })


    )
  }
}
